import { sanitizePortalHTMLContent } from "@tellescope/utils";
import { CHART_THEMES } from "./context";
import type { ChartConfig } from "./context";

/**
 * Emits `--color-<key>` variables for series configured with per-theme `theme` colors. These need
 * a `.dark`-scoped CSS selector, which an inline `style` prop cannot express — hence a `<style>`
 * tag. Series with a plain `color` are handled inline on the Chart container and never reach here,
 * so this renders nothing in the common case.
 */
export const ChartStyle = ({ id, config }: { id: string; config: ChartConfig }) => {
  const themedConfig = Object.entries(config).filter(([, itemConfig]) => itemConfig.theme);

  if (!themedConfig.length) {
    return null;
  }

  const html = sanitizePortalHTMLContent(
    Object.entries(CHART_THEMES)
      .map(
        ([theme, prefix]) => `
${prefix} [data-chart=${id}] {
${themedConfig
  .map(([key, itemConfig]) => {
    const color = itemConfig.theme?.[theme === "dark" ? "dark" : "light"];
    return color ? `  --color-${key}: ${color};` : null;
  })
  .join("\n")}
}
`
      )
      .join("\n")
  );

  return <style dangerouslySetInnerHTML={{ __html: html }} />;
};
